import React from 'react'
import ReactDOM from 'react-dom'
import ResetCSS from './ResetCSS'
import GlobalStyle from './style/Global'
import Providers from './Providers'
import App from './pages/App'
import reportWebVitals from './reportWebVitals'
import 'react-toastify/dist/ReactToastify.css'

ReactDOM.render(
  <React.StrictMode>
    <Providers>
      <ResetCSS />
      <GlobalStyle />
      <App />
    </Providers>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
